




















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { JinroRoles } from "@/services/jinro-roles";
import Default from "./Default.vue";
import GameEnded from "./GameEnded.vue";
import PublicViewing from "./PublicViewing.vue";
import AlreadyKilled from "./AlreadyKilled.vue";
import PlayerWithJinroRole from "./PlayerWithJinroRole.vue";

@Component({
  components: {
    GameEnded,
    PublicViewing,
    AlreadyKilled,
    PlayerWithJinroRole,
    Default,
  },
})
export default class EachPlayerNameList extends Vue {
  get hasBeenGameEnded(): boolean {
    if (!this.$store.state.jinroGame) {
      return false;
    }

    return !!this.$store.state.jinroGame.hasBeenGameEnded;
  }

  get isPlayerWithJinroRole(): boolean {
    if (
      !this.$store.state.jinroPlayerGame ||
      !this.$store.state.jinroPlayerGame.role
    ) {
      return false;
    }

    return this.$store.state.jinroPlayerGame.role === JinroRoles.Jinro;
  }
  get isPublicViewing(): boolean {
    // public view path example:  /j/TAYBteCF9uJnFVyUtP8W/public
    const elmnts = this.$route.path.split("/");

    return elmnts.length > 3 && this.$route.path.split("/")[3] === "public";
  }

  get isPlayerAlreadyKilled(): boolean {
    if (
      !this.$store.state.jinroPlayerGame ||
      !this.$store.state.jinroPlayerGame.isKilled
    ) {
      return false;
    }

    return this.$store.state.jinroPlayerGame.isKilled;
  }
}
